import React from 'react'
import { AddressLink, TruncateAddress } from 'components/Utils'

const FoundationWalletsTableColumns = [
  {
    title: 'Address',
    dataIndex: 'address',
    render: (address) => (
      <AddressLink address={address}>
        <TruncateAddress address>{address}</TruncateAddress>
      </AddressLink>
    ),
    width: 200,
  },
  {
    title: 'Note',
    dataIndex: 'note',
  },
]

export default FoundationWalletsTableColumns
